const GalleryController = () => import('./Controller')
const SortGallery = () => import('./SortGallery')

export default function installComponents(Vue) {
  Vue.component('GalleryController', GalleryController)
  Vue.component('SortGallery', SortGallery)
}
